import type { PaintedWallGeometry, WallPoint } from '../../../shared/painted-wall-geometry';
import { ecId, upper, type JanusCtx, type Row } from '../context';
import type { JanusInput } from '../janus';
import { ICE_WALL } from './painted-wall-ice-cast';
import type { PlacedAoeReaders } from './expand-placed-aoe-targets';

export interface IceWallDisplacementReaders {
  prepareIceWallDisplacements?: (ctx: JanusCtx, wall: PaintedWallGeometry, placed: PlacedAoeReaders) => void;
}

/** The page supplies the existing landing writer; shared spell dispatch never imports scene movement. */
export const iceWallDisplacements = new WeakMap<JanusCtx, {
  moves: Array<{ id: string; end: WallPoint }>;
  applied: boolean;
  land: (ctx: JanusCtx, row: Row, at: WallPoint) => void;
}>();

/** After counterspell, before the sole damage dispatch: death/corpse effects see the actual landing. */
export function applyIceWallDisplacements(ctx: JanusCtx, input: JanusInput): void {
  if (ctx.trigger || upper(input.abilityId) !== ICE_WALL || input.paintedWall?.abilityId !== ICE_WALL) return;
  const plan = iceWallDisplacements.get(ctx);
  if (!plan || plan.applied) return;
  for (const move of plan.moves) plan.land(ctx, ctx.members.get(move.id)!, move.end);
  plan.applied = true;
}

/** A displaced cast target receives its initial save/damage, but is outside the new zone's ongoing effects. */
export function iceWallDisplacedTarget(ctx: JanusCtx, input: JanusInput, target: Row): boolean {
  const plan = iceWallDisplacements.get(ctx);
  return !ctx.trigger && upper(input.abilityId) === ICE_WALL && input.paintedWall?.abilityId === ICE_WALL
    && !!plan?.applied && plan.moves.some(move => move.id === ecId(target));
}
